/**
 * AirLabs API Service
 * Maps AirLabs response to the application's internal data structure
 */

const API_KEY = import.meta.env.VITE_AIRLABS_API_KEY;
const BASE_URL = 'https://airlabs.co/api/v9';

// Helper to map AirLabs data to our existing UI structure
const mapAirlabsToApp = (flight) => ({
  flight: {
    iata: flight.flight_iata || flight.flight_number || '??',
    icao: flight.flight_icao
  },
  airline: {
    name: flight.airline_name || 'Airline',
    icao: flight.airline_icao
  },
  departure: {
    airport: 'Sacramento',
    iata: flight.dep_iata,
    // AirLabs uses dep_gate for the gate number
    gate: flight.dep_gate || 'TBD',
    terminal: flight.dep_terminal || 'B',
    scheduled: flight.dep_time || flight.dep_estimated || new Date().toISOString()
  },
  arrival: {
    airport: flight.arr_name || 'Destination',
    iata: flight.arr_iata,
    scheduled: flight.arr_time || flight.arr_estimated || new Date().toISOString()
  },
  flight_status: flight.status || 'active'
});

export const fetchSmfFlights = async () => {
  if (!API_KEY || API_KEY === 'your_airlabs_api_key_here') {
    console.warn("AirLabs API Key missing.");
    return [];
  }

  try {
    // We fetch live flights departing from SMF
    const response = await fetch(
      `${BASE_URL}/flights?api_key=${API_KEY}&dep_iata=SMF`
    );
    const data = await response.json();
    
    if (data.error) throw new Error(data.error.message);
    
    const rawFlights = data.response || [];
    return rawFlights.map(mapAirlabsToApp);
  } catch (error) {
    console.error('AirLabs Fetch Error:', error);
    return [];
  }
};

export const fetchFlightStatus = async (flightIata) => {
  if (!API_KEY || API_KEY === 'your_airlabs_api_key_here') return null;

  try {
    const response = await fetch(
      `${BASE_URL}/flight?api_key=${API_KEY}&flight_iata=${flightIata}`
    );
    const data = await response.json();
    
    if (data.error || !data.response) return null;
    return mapAirlabsToApp(data.response);
  } catch (error) {
    console.error('AirLabs Status Error:', error);
    return null;
  }
};